/**
 * @fileoverview Vue插件安装
 * @description 简化的Vue插件，用于全局安装SDK，包含QrCodeLogin和MapLocationPicker组件
 * @author wangzhongsheng
 * @version 2.1.0
 */

import QrCodeLogin from '../components/QrCodeLogin.vue'
import MapLocationPicker from '../components/MapLocationPicker.vue'
import { request } from './request.js'
import { detectStreetKey, setCurrentStreet } from './street.js'
import { configureSDK } from './config.js'

/**
 * Vue插件安装函数
 * @param {Object} app - Vue应用实例
 * @param {Object} options - 插件配置选项
 * @param {string} [options.baseURL] - API基础URL
 * @param {number} [options.timeout] - 请求超时时间
 * @param {string} [options.tokenKey] - token存储键名
 * userKey - userinfo存信名
 * @param {string} [options.loginUrl] - token过期后跳转的页面，默认为 '/'
 * @param {string[]} [options.tokenErrorCodes] - 需要触发登录跳转的token错误码数组
 * @param {string} [options.streetKey] - 街道标识
 */
function install(app, options = {}) {
  // 应用全局配置
  if (options.baseURL || options.timeout || options.tokenKey || options.userKey || options.loginUrl || options.tokenErrorCodes) {
    console.log('🔧 通过Vue插件配置SDK:', options)
    configureSDK(options)
  }
  
  // 全局注册组件
  app.component('QrCodeLogin', QrCodeLogin)
  app.component('MapLocationPicker', MapLocationPicker)
  
  // 初始化街道配置
  const streetKey = options.streetKey || detectStreetKey()
  if (streetKey) {
    setCurrentStreet(streetKey)
  }
  
  // 全局属性注入（简化版）
  app.config.globalProperties.$bjchyAuth = {
    request, // 使用全局配置的请求实例
    streetKey,
    detectStreetKey,
    setCurrentStreet
  }
  
  // provide/inject支持
  app.provide('bjchyAuth', {
    request, // 使用全局配置的请求实例
    streetKey,
    detectStreetKey,
    setCurrentStreet
  })
}

export default {
  install
} 